import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Alert } from './alert.interface';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  // observable alert
  alert = new Subject<Alert | null>();

  constructor() { }

  setAlert(alert: Alert) {
    this.alert.next(alert);
    if (alert.dismissOnTimeout > 0) {
      setTimeout(() => {
        this.clearAlert();
      }, alert.dismissOnTimeout);
    }
  }

  clearAlert() {
    this.alert.next(null);
  }
}
